import { DeleteFilled } from "@ant-design/icons/lib/icons";
import { Button, message, Popconfirm, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteDataSlider, getDataSlider } from '../../../config/Redux/action';

const DashboardSlider = () => {
    const dispatch = useDispatch();
    const [sliders, setSliders] = useState([]);
    const loading = useSelector((state) => state.product.isLoading);

    const getData = async () => {
        const data = await dispatch(getDataSlider());
        setSliders(
        data.map((slider, index) => {
            return {
            key: index,
            no: index + 1,
            id: slider.id,
            image_url: slider.data.image_url,
            title: slider.data.title,
            subtitle: slider.data.subtitle,
            };
        }),
        );
    };

    useEffect(() => {
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDelete = (id) => {
        dispatch(deleteDataSlider(id));
        getData();
    };


    const dataSource = sliders;

    const columns = [
      {
        title: 'No',
        dataIndex: 'no',
        key: 'no',
        align: 'center',
        width: '10%',
      },
      {
        title: 'Cover',
        dataIndex: 'image_url',
        key: 'image_url',
        align: 'center',
        width: '30%',
        render: (res) => {
          return <img src={res} alt='gambar' width={250} height={200} />;
        },
      },
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        align: 'center',
        width: '20%%',
      },
      {
        title: 'Subtitle',
        dataIndex: 'subtitle',
        key: 'subtitle',
        align: 'center',
        width: '25%',
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        width: '15%',
        render: (result) => {
          return (
            <>
              <Popconfirm
                onConfirm={() => handleDelete(result.id)}
                title={'Do You Want To Delete Data?'}
                onCancel={() => message.error('Data is Not Deleted')}
              >
                <Button
                  icon={<DeleteFilled />}
                  danger
                  type='primary'
                  style={{ display: 'inline-block', marginLeft: '12px' }}
                />
              </Popconfirm>
            </>
          );
        },
      },
    ];

return <Table dataSource={dataSource} columns={columns} loading={loading} />;
}

export default DashboardSlider